import { createCnaeListStore } from '@/stores/factories/cnaeListStoreFactory';
import systemAdminApi from '@/api/modules/systemAdmin';

export const useSystemCnaeListStore = createCnaeListStore('systemCnaeList', systemAdminApi);